// Calendar styles - extracted from inline styles

export const column_heading = {
  height: 50,
  fontSize: 14,
  border: '1px solid #B6C4CD',
  textAlign: 'center',
  background: '#F0F3F5',
  fontWeight: 'bold',
  mb: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  p: 2,
};

export const time_slots_styles = {
  height: 65,
  fontSize: 14,
  fontFamily: 'Lato',
  fontWeight: 700,
  p: 0,
  m: 0,
  lineHeight: '65px',
  textAlign: 'center',
  border: '1px solid #B6C4CD',
  background: '#F0F3F5',
  '&:not(:last-of-type)': {
    mb: '2px',
  },
};

export const links_styles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  color: '#fff',
  position: 'relative',
  lineHeight: 1.1,
  '& p, & span': {
    lineHeight: 1.1,
  },
};

export const queue_row_styles = {
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  gap: '2px',
  pb: 1,
  mb: 2,
  '&::-webkit-scrollbar': {
    height: 8,
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: 4,
  },
};

export const queue_item_styles = {
  minWidth: 80,
  height: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 1,
  cursor: 'grab',
  '&:active': {
    cursor: 'grabbing',
  },
};

export const calendar_grid_styles = {
  // Clean grid styles - removed Misc column styling artifacts
};

export const status_icon_styles = {
  width: 15,
  height: 15,
  filter: 'drop-shadow(0 0 1px white) drop-shadow(0 0 1px white)',
};

export const drag_overlay_styles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};
